import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Outbox
import Outbox from "../pages/Outbox/DatatableTables";
import MessageDetail from "../pages/Outbox/MessageDetail";
import ScheduledMessages from "../pages/ScheduledMessages";

// Contacts
import Contacts from "../pages/Contacts/ContactList/contacts-list";
import ContactsAll from "../pages/Contacts/AllContacts/contacts-all";
import Contactdetail from "../pages/Contacts/ContactList/contactlistdetail";

// Account
import Account from "../pages/MyAccount/user-profile";
import AccountSettings from "../pages/MyAccount/AccountSettings";


const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/outbox", component: <Outbox /> },
  { path: "/scheduled", component: <ScheduledMessages /> },
  { path: "/message-detail/:id", component: <MessageDetail /> },
  { path: "/contacts", component: <ContactsAll /> },
  { path: "/contact-list", component: <Contacts /> },
  { path: "/contact-list-detail/:id", component: <Contactdetail /> },
  { path: "/account", component: <Account /> },
  { path: "/account-settings", component: <AccountSettings /> },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/reset-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
